import React from 'react';
import { InlineNotification } from '../../../../molecules/InlineNotification/InlineNotification';
/**
 * Client-side-validation rejection alert (E2E-38) -- size/type rejections never reach the queue,
 * so this is the only feedback the user gets. Purely local UI state owned by the parent
 * `AddAttachmentsBrushaway` (not part of the injected upload queue -- see that file's module doc).
 */
export function RejectedFilesAlert({ files, labels, onDismiss }) {
    if (files.length === 0)
        return null;
    return (React.createElement(InlineNotification, { variant: "error", title: labels.rejectedAlertTitle(files.length), dismissible: true, onDismiss: onDismiss },
        React.createElement("ul", { className: "qmb-ui-add-attachments-brushaway__rejected-list" }, files.map((file) => (React.createElement("li", { key: file.id }, labels.rejectedAlertMessage(file.name, file.sizeLabel)))))));
}
